import { useEffect, useState } from 'react'
import { getCustomerRecording } from '@/api/customers'
import { Button } from '@/components/ui/button'

export function CustomerRecordingPlayer({ customerId }: { customerId: number }): React.ReactElement {
  const [audioUrl, setAudioUrl] = useState<string | null>(null)
  const [isLoading, setIsLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState<string | null>(null)

  const hasRecording = audioUrl !== null
  const hasError = errorMessage !== null

  useEffect(() => {
    return () => {
      if (audioUrl) {
        URL.revokeObjectURL(audioUrl)
      }
    }
  }, [audioUrl])

  const handleLoadRecording = async (): Promise<void> => {
    setIsLoading(true)
    setErrorMessage(null)

    try {
      const blob = await getCustomerRecording(customerId)
      setAudioUrl(URL.createObjectURL(blob))
    } catch {
      setErrorMessage('Kunde inte hämta samtalsinspelningen just nu.')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="space-y-3">
      {!hasRecording && (
        <Button
          variant="outline"
          className="rounded-none"
          disabled={isLoading}
          onClick={handleLoadRecording}
        >
          Spela upp samtal
        </Button>
      )}

      {hasRecording && (
        <audio
          controls
          src={audioUrl ?? undefined}
          className="w-full"
        />
      )}

      {hasError && <p className="text-sm text-destructive">{errorMessage}</p>}
    </div>
  )
}
